<template>
  <div class="w-100" id="new-data-table">

    <div style="position: relative" v-if="exportarExcel">
      <div class="d-flex" style="position: relative">
        <export-button
          :headers="headers"
          :data="data"
          :nombreArchivo="idtabla"
          :exportExcelCustom="exportExcelCustom"
          :isCustomExport="isCustomExport"
          style="margin: auto -0px -50px auto;"
          :style="[
            btnSpecificZIndex === 1 
            ? ( zIndexModal || zIndexTablaModal
              ? { 'z-index': '0' }
              : { 'z-index': '1' } )
            : { 'z-index': btnSpecificZIndex } 
          ]"
        />

      </div>
    </div>
    <div  class="d-flex justify-content-end align-items-center">

      <!-- Buscar -->
      <div class="d-flex d-inline mb-3" :class="[
          exportarExcel ? 'margin-right-60' : '',
          withSearch ? '' : 'invisible'
        ]">
        <div for="bucar" class="mt-1">Buscar</div>
        <input
          type="text"
          label="buscar "
          class="form-control form-control-sm ml-3"
          @keyup="filtrarTabla"
          v-model="searchValue"
        />
      </div>
    </div>

    <!-- Tabla -->
    <div class="header_fixed">
      <table class="table-bordered" :id="nombreTabla">
        <thead>
          <tr>
            <th v-if="check" class="text-center bg-light" style="width: 36px">
              <input
                v-if="showAllSelectChecks"
                class="form-check-input checks-datatable"
                type="checkbox"
                id="checkbox-id-all"
                ref="select_all_chbx"
                v-model="checkAll"
                @click="selectAllPage( $event )"
                :disabled="searchValue !== ''"
              />
            </th>

            <th type="checkbox" :style="{ width: '10px' }" class="bg-light" v-if="numerador">#</th>

            <template v-if="!customHeaders">
              
              <th
                v-for="(item, index_header) in headers"
                :key="index_header.title"
                class="text-center bg-light"
              >
                {{ item }}
              </th>
            </template>
            <template v-else>
              <th
                v-for="(item, index_header) in headers"
                :key="index_header"
                class="text-center bg-light"
                :style="{ width: item.width }"
              >
                <div v-if="sortHeaders && item.title !== 'Acciones'"  class="w-100 d-inline-flex cursor-pointer" @click="sort(index_header)" >
                  <div> {{ item.title }} </div>
                  <div class="ml-2">
                    <i class="fas fa-sort-up position-absolute text-gray" :ref="'refHeaderUp' + index_header"></i>
                    <i class="fas fa-sort-down text-gray" :ref="'refHeaderDown' + index_header"></i>
                  </div>
                </div>
                <span v-else >
                  {{ item.title }}
                </span>
              </th>
            </template>
          </tr>
        </thead>
        <tbody v-if="dataAux.length > 0" >
          <tr v-for="(item, index) in dataAux" :key="index" >

            <td
              v-if="check"
              type="checkbox"
              
            >
              <input
                class="form-check-input checks-datatable"
                type="checkbox"
                :id="'checkbox-id-'  + ( ( max * ( pagActual - 1 ) ) + index )"
                :checked="checks.includes( ( ( max * ( pagActual - 1 ) ) ) + index )"
                @click="cambiarEstadoCheck($event, ( ( max * ( pagActual - 1 ) ) + index ))"
              />
            </td>
            <td
              v-if="numerador"
              v-text="( ( max * ( pagActual - 1 ) ) + index ) + 1"
            ></td>

            <template v-if="formulario">
            
              <td
                v-for="(item_data, index_data) in item.data"
                :key="index_data"
              >
                <template  v-for="(type, index_type) in item.type">
                  <template v-if="type.key == index_data">
                    
                    <input
                      v-if="type.type == 'textbox'"
                      class="form-control"
                      :key="index_type"
                      placeholder=""
                      v-model="item.data[index_data]"
                    />

                    <input
                      :key="index_type"
                      :id="index_type"
                      v-if="type.type == 'checkbox'"
                      class="form-check-input"
                      type="checkbox"
                      @click="type.function ? funcionAuxiliar(
                        type.nameCategory,
                        $event,
                        index,
                        index_data
                      ) : '' "
                    />

                    <input
                      :key="index_type"
                      :id="index_type"
                      v-if="type.type == 'checkboxset'"
                      type="checkbox"
                      v-model="item.data[index_data]"
                      class="form-check-input"
                      @click="type.function ? funcionAuxiliar(
                        type.nameCategory,
                        $event,
                        index,
                        index_data
                      ) : '' "
                    />

                    <ui-select
                      v-if="type.type == 'select'"
                      class="form-control"
                      :key="index_type"
                      has-search
                      placeholder="Seleccionar"
                      searchPlaceholder="Buscar"
                      v-model="item.seleccionados_aux.deposito"
                      :options="item_data"
                      :keys="{ value: 'id', label: 'name' }"
                      @change="type.function ? funcionAuxiliar(
                        type.nameCategory,
                        $event,
                        index,
                        index_data
                      ) : '' "
                    />

                    <template v-if="type.type == 'select2'">
                      <ui-select
                        class="form-control"
                        :key="index_type"
                        has-search
                        placeholder="Seleccionar"
                        searchPlaceholder="Buscar"
                        v-model="item.data[index_data]"
                        :options="item.selects[index_data]"
                        :keys="{ value: 'id', label: 'name' }"
                      />
                    </template>

                    <template v-if="type.type == 'text'">
                      {{ item.data[index_data] }}
                    </template>
                    
                    <date-picker
                      v-if="type.type == 'date'"
                      :placeholder="item.data[index_data].placeholder === undefined
                          ? 'Fecha'
                          : item.data[index_data].placeholder"
                      type="date"
                      class="input_fecha"
                      value-type="format"
                      :key="index_type"
                      v-model="item.data[index_data]"
                    />
                  </template>
                </template>
              </td>
            
            </template>

            <template  v-else>
              <td v-for="(item_data, index_data) in item.data" :key="index_data"> 
                <div class="new-data-table__text">

                  <span  > {{item_data}} </span>
                </div>
              </td>
            </template>


            <td v-if="accionesAux.length > 0">
              <a
                v-for="(item_acciones, index_2) in accionesAux[index]"
                :key="index_2"
                class="btn btn-sm"
                @click="filaSeleccionada( searchValue.length > 0 ? item.indexInit : ( ( max * ( pagActual - 1 ) ) + item.indexInit ), item_acciones.title)"
              >
              <i :class="item_acciones.icon" :title="item_acciones.title"></i>
              </a>
            </td>
          </tr>
        </tbody>

        <tbody v-else >
          <tr >
            <td colspan="100%" > <h5 class="text-center my-2 text-secondary"> No hay registros disponibles </h5>  </td>
          </tr>
        </tbody>


      </table>
    </div>
    <!-- Footer -->
    <div class="d-flex justify-content-between mt-3">
      <div class="d-flex d-inline" style="visibility: hidden;">
        <small style="width: 280px;" class="mt-1" >Cantidad de registros</small>
        <select
          name="registros"
          class="form-control form-control-sm ml-2"
          @change="modificarCantRegistrosAmostrar($event)"
        >
          <option value="10">10</option>
          <option value="30">30</option>
          <option value="60">60</option>
          <option value="100">100</option>
          <option value="200">200</option>
        </select>
      </div>
      <nav aria-label="...">
        <ul class="pagination">
          <!-- Btn volver -->
          <li
            class="page-item"
            :style="[pagActual > 1 && { cursor: 'pointer' }]"
            :class="[pagActual == 1 && 'disabled']"
          >
            <a class="page-link" :disabled="pagActual == 1"  @click="paginarContenido(( pagActual -1 ), limitCantPag)">Anterior</a>
          </li>

          <!-- Lista de botones de páginación dínamica -->
          <li
            v-for="(item, index) in paginador.botones"
            :key="index"
            :id="`btn-${item}`"
            style="text-align: center; cursor: pointer"
            class="page-item page-item"
            :class="[index == 0 && 'active']"
          >
            <!-- Btn con ... -->
            <div v-if="item == '...'" class="page-link disabled">
              {{ item }}
            </div>

            <!-- Btn con númeración -->
            <a
              v-else
              class="page-link"
              @click="paginarContenido(item, limitCantPag)"
              >{{ item }}</a
            >
          </li>

          <!-- Btn Siguiente -->
          <li class="page-item" style="cursor: pointer">
            <a  class="page-link" 
              :class="pagActual == paginador.ultimaPag && 'disabled'" 
              :disabled="pagActual == paginador.ultimaPag" 
              @click="paginarContenido(pagActual+1, limitCantPag)"
            >
              Siguiente
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ExportButton from "../common/ExportButton";

export default {
  components: {
    ExportButton,
  },
  props: {
    headers: { type : Array , default:() => [] }, // Titulos para cabecera de la tabla
    data: Array , // Contenido o información que mostrara la tabla
    acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
    paginacion: Boolean, // Si la tabla tedra activa la opción de paginación
    max: { type: Number, default: 10 }, // Numero de filas por cada pagina
    customHeaders: Boolean, // Permite asignar el ancho de cada cabecera mediante un array de configuración {title: '', width: ''}
    idtabla: {
      type: String,
      default: "id_generico",
    },
    isCustomExport: Boolean,
    funcionAuxiliar: { type: Function, default: () => ({}) },
    numerador: { type: Boolean, default: false }, // Permite agregar numeración correlativca como indicador, esta opción esta deshabilitada por defecto
    seleccionar: { type: Function, default: () => ({}) },
    check: { type: Boolean, default: false }, // Permite agregar un checkbox como primer elemento de la tabla, esta opción esta deshabilitada por defecto
    filaChekeada: { type: Function, default: () => ({}) },
    exportarExcel: { type: Boolean, default: false }, 
    exportExcelCustom: { type: Function, default: () => ({}) },
    formulario: { type: Boolean, default: false }, // Permite agregar contenido tipo select, textbox y checkbox a la tabla , esta opción esta deshabilitada por defecto
    btnSpecificZIndex: { type: Number, default: 1 }, // Permite agregar contenido tipo select, textbox y checkbox a la tabla , esta opción esta deshabilitada por defecto
    // rowsSelected: { type: Array, default: () => ([]) } // devuelve todas las filas seleccionadas de una página
    vaciarArreglo: {type: Function,default:() => ({})},
    sortHeaders: { type: Boolean, default: false }, 
    withSearch: { type: Boolean, default: false }, 
    showAllSelectChecks: { type: Boolean, default: true }, 
  },
  model: {
    prop: 'rowsSelected',
    event: 'rowsSelectedAssign'
  },
  data() {
    return {
      loading: true,
      nombreTabla: "id_tabla_" + this.idtabla,
      dataAux: this.data,
      dataModificada: [],
      accionesAux: this.acciones,
      indiceFinal: [],
      paginador: {
        primeraPag: 1,
        ultimaPag: 0,
        cantPag: 0,
        cantBotonesAmostrar: 5,
        botones: [],
        paginas: [],
      },
      pagActual: 1,
      numberRegisters: [],
      limitCantPag: this.max,
      limiteInicialPag: 5,
      limiteFinalPag: 5,
      iteracionPaginado: 1,
      checks:[],
      checkAll: false,
      rows: this.rowsSelected,
      searchValue : ""
    };
  },
  computed: {
    ...mapState(["zIndexModal", "zIndexTablaModal"]),
    rowsSelectedAssign: {
      get: function() {
          return this.rowsSelected
      },
      set: function( value ) {
          this.$emit('rowsSelectedAssign', value );
      }
    }
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["ActionSetLoading"]),

    selectAllPage({ target }) {

      const { checked } = target;

      if (checked) {

        let startIndex = 0;

        if (this.pagActual > 1) {

          startIndex = (this.pagActual * this.max) - this.max;

        }

        for (startIndex; startIndex < this.numberRegisters.length; startIndex++) {

          this.checks.push(this.numberRegisters[startIndex]);

          const accion = "fila_chekeada";

          this.filaChekeada({ id: this.numberRegisters[startIndex], estado: checked, accion });

        }

      } else {

        this.checks = [];

        this.vaciarArreglo();
        
      }

    },
    filaSeleccionada(id, accion) {
      this.seleccionar({ id, accion });
    },

    cambiarEstadoCheck(event, id) {
      let estado = event.target.checked ;

      if(estado){
        this.checks.push( id ) ;
      } else {
        this.checks = this.checks.filter( element =>  element !== id );
      }
      let accion = "fila_chekeada";
      this.filaChekeada({ id, estado, accion });
      this.rowsSelectedAssign = this.checks;
    },

    configuracionDatatable() {
      let me = this;
    
      me.ActionSetLoading(false);
    },

    // Función que entrega la cantidad de páginas que tendra una tabla dependiendo de la cantidad de registros
    // y la cantidad designada de registros a mostrar
    obtenerCantidadPagina() {
      // Valida que dataAux cuente con registos, de lo contrario no hace nada
      this.dataAux.length == 0 && false;

      // Obtiene la cantidad de páginas en base a la cantidad de registros en dataAux / limitCantPag
      let cantidad = Math.ceil(this.dataAux.length / this.limitCantPag);

      // En primera instancia primeraPag se inicializa en 1
      this.paginador.primeraPag = 1;
      this.paginador.ultimaPag = cantidad;

      // Creación de los btns con la función crearBotonesPaginado
      this.crearBotonesPaginado();
    },

    // Función que crea la cantidad btns mediante un rango de inicio y termino
    crearBotonesPaginado() {
      let newButtons = [];

      if( this.pagActual > 4 ){
        newButtons.push(1);
        newButtons.push("...");
      } 

      for (let indexButton = (this.pagActual- 3); indexButton <= this.pagActual; indexButton++) {
        indexButton > 0 && newButtons.push(indexButton);
      }

      for (let indexButton = (this.pagActual+1); indexButton <= (this.pagActual+3); indexButton++) {
        indexButton <= this.paginador.ultimaPag && newButtons.push(indexButton);     
      }

      if( (this.pagActual + 3) <= this.paginador.ultimaPag ){
        newButtons.push("...");
        newButtons.push(this.paginador.ultimaPag);
      } 
      this.paginador.botones = newButtons ;
      
    },

    // Esta función es la encargada de mostrar la información de la página seleccionada
    // recibe como parámetros la pagina seleccionada y el máximo de registros por página
    paginarContenido(currentPage = 1, maxPage) {

      let from, to;

      if (parseInt(currentPage) === 1) {

        from = 0;

        to = this.limitCantPag;

      } else {

        // Asignar rango de busqueda dentro del arreglo que contiene la información
        to = currentPage * maxPage;

        from = to - maxPage;

      }

      this.updateNumberRegisters(from, to);

      this.filtrar();

      this.dataAux = this.searchValue.length > 0
        ? this.dataAux.slice(from, to)
        : this.data.slice(from, to).map((d, i) => ({ ...d, indexInit: i }));


      // // if (this.searchValue.length > 0) {
      // if (this.dataAux.length) {
      //
      //   let accionesTemp = [];
      //
      //   this.dataAux.map( ({indexInit }) => {
      //     accionesTemp.push(this.acciones[indexInit]);
      //   });
      //
      //   this.accionesAux = accionesTemp;
      //
      // }else{

      this.accionesAux = this.acciones.slice(from, to);

      // }
      //
      // // this.accionesAux = this.searchValue.length > 0
      // //                     ? this.dataAux.map( (d,i) => this.acciones[ i ] )
      // //                     : this.acciones.slice(from, to) ;

      this.pagActual = currentPage;

    },
    updateNumberRegisters( from, to ){
      
      let arrayTemp = [] ;
      for (let i = 0; i < to; i++) {
        arrayTemp.push( i );
      }
      this.numberRegisters = arrayTemp ;
    },

    // Esta funcionalidad muestra la cantidad de registros seleccionados en la parte superior de la tabla
    modificarCantRegistrosAmostrar(event) {
      let { value: valor } = event.target;

      this.limitCantPag = valor;

      this.paginador.botones = [];
      this.paginador.paginas = [];
      this.paginarContenido();
      this.obtenerCantidadPagina();
    },

    asignarClaseActive() {
      this.removeClassActiveAll();

      let elementNew = document.getElementById(`btn-${this.pagActual}`) ;

      if( elementNew !== null ) elementNew.classList.add("active");
    },

    removeClassActiveAll(){
      let elementsPaginator = document.querySelectorAll(".page-item"); 
      elementsPaginator.forEach( el => el.classList.remove("active") );
    },

    paginate(){
      this.obtenerCantidadPagina();
      this.paginarContenido();
    },

    filtrar(){

      const value = this.searchValue.toLowerCase() ;

      if( this.data.length > 0 && value.length > 0 ) {

        const keys = Object.keys( this.data[0].data ).map( val => +val ) ;

        this.dataAux = this.data.filter( (item,indexInit) => {
          
          item.indexInit = indexInit ;

          let findValue = false ;

          for ( const key of keys) {           
                if (item.data[key] != null && item.data[key].toString().toLowerCase().indexOf(value) != -1) {
                    findValue = true;
                    break;
                
            }
          }
          return findValue && item ;
        });
      } else if( value === "" ) {
        this.dataAux = this.data ;
      }
    },
    filtrarTabla() {

      if( this.searchValue.length > 0 ) {
        this.filtrar();
        this.obtenerCantidadPagina();
        this.paginarContenido();
      } 
      else if( this.searchValue === "" ){
        this.filtrar();
        this.obtenerCantidadPagina();
        this.paginarContenido();
      }
    
    },
    sort( index ){
      
      if( !this.$refs[`refHeaderUp${index}`] ) return ;

      
      if( this.$refs[`refHeaderUp${index}`][0].classList.contains("text-gray") ){

        this.headers.forEach( (h,i) => {
          this.$refs[`refHeaderDown${ i }`] && this.$refs[`refHeaderDown${ i }`][0].classList.add("text-gray") ;
          this.$refs[`refHeaderUp${ i }`]   && this.$refs[`refHeaderUp${ i }`][0].classList.add("text-gray") ;
        }) ;

        this.$refs[`refHeaderUp${index}`][0].classList.remove("text-gray") ;
        
        this.$refs[`refHeaderDown${index}`][0].classList.add("text-gray") ;

        this.dataAux = this.dataAux.sort(function(a, b) {
          const textA = a.data[ index ];
          const textB = b.data[ index ];
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
      }
      else {

        this.headers.forEach( (h,i) => {
          this.$refs[`refHeaderDown${ i }`] && this.$refs[`refHeaderDown${ i }`][0].classList.add("text-gray") ;
          this.$refs[`refHeaderUp${ i }`]   && this.$refs[`refHeaderUp${ i }`][0].classList.add("text-gray") ;
        }) ;

        this.$refs[`refHeaderUp${index}`][0].classList.add("text-gray") ;
        
        this.$refs[`refHeaderDown${index}`][0].classList.remove("text-gray") ;

        this.dataAux = this.dataAux.sort(function(a, b) {
          const textA = a.data[ index ];
          const textB = b.data[ index ];
          return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
        });
      }

    }
  },
  created() {
    this.paginate();
  },
  watch: {
    data(_new){
      this.searchValue = "" ;
      this.dataAux = _new.map( (d ,i) => ({...d , indexInit : i } ) ) ;
      this.paginate();
      this.checks = [];
    },
    pagActual: async function (nuevo) {
      if( nuevo > 3 ){
        await this.crearBotonesPaginado( (nuevo - 3), (nuevo + 3)) ;
        await this.asignarClaseActive() ;

      } else {
        await this.crearBotonesPaginado( 1, 4 ) ;
        await this.asignarClaseActive() ;
      }
    },
    rows:  function( _new ) {
        this.rowsSelected = _new;
    },
    searchValue: function(_new) {

      if(_new !== ""){

        this.checks = [];

        this.vaciarArreglo();

        this.check && (this.$refs.select_all_chbx.checked = false);

      }

    }
  }
};
</script>

<style>

.new-data-table{
  height: 60vh !important;
}

.new-data-table__text {
  max-height: 90px !important;
  overflow-y: auto;

}

#new-data-table table {
  border-collapse: collapse;
  width: 100%;
}

#new-data-table th, #new-data-table td {
  padding: 10px;
  font-size: 14px;
}

#new-data-table tr:hover td {
  cursor: pointer;
  background-color: #b9b9b9;
  font-weight: 400;
  color: #fff;
}

#new-data-table .header_fixed {
  height: 100% ;
  overflow: auto;
  margin-top: 3px;
  border: 1px solid #dddddd;
}

#new-data-table .header_fixed thead th {
  position: sticky;
  background: #dc3545;
  top: 0;
  color: #fff;
}

#new-data-table tr:nth-child(even) {
  background: #e2e0e0;
}

#new-data-table ::-webkit-scrollbar {
  width: 6px;
}

#new-data-table ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

#new-data-table ::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
#new-data-table .form-check-input {
  position: unset;
  margin-left: 0px;
}

#new-data-table .invisible { 
  visibility: hidden; 
}

#new-data-table .margin-right-60 {
  margin-right: 10pc;
}
</style>
